/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consult_Q5_WhatsappInputs */

const en_consult_q5_whatsapp = /** @type {(inputs: Consult_Q5_WhatsappInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WhatsApp (optional)`)
};

const id_consult_q5_whatsapp = /** @type {(inputs: Consult_Q5_WhatsappInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WhatsApp (opsional)`)
};

/**
* | output |
* | --- |
* | "WhatsApp (optional)" |
*
* @param {Consult_Q5_WhatsappInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const consult_q5_whatsapp = /** @type {((inputs?: Consult_Q5_WhatsappInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consult_Q5_WhatsappInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_consult_q5_whatsapp(inputs)
	return en_consult_q5_whatsapp(inputs)
});